<template>
    <div class="l-meeting-notes">
        <!-- Headline -->
        <div>
            <span
                v-b-popover.hover.bottomright="{
                    content: $t('meetings.labelNotesVisibility'),
                }"
                class="agenda-question"
                >{{ $t("meetings.labelSharedNotes") }}</span
            >

            <span
                v-b-popover.hover.bottomright="{
                    content: $t('meetings.btnSaving'),
                }"
                class="l-default-margin-s color-grey hidden-xs"
            >
                <i v-if="updatingNotes" class="fa fa-refresh fa-spin l-default-margin-s"></i>
            </span>
            <span
                class="pull-right hidden-xs clickable"
                tabindex="0"
                @click="toggleCopyNotes()"
                @keyup.enter="toggleCopyNotes()"
            >
                <i :class="[copyNotes ? 'fal fa-check-square' : 'fal fa-square']"></i>
                <span class="color-grey l-default-margin-s">{{
                    $t("meetings.labelCopyNotes")
                }}</span>
            </span>
        </div>

        <br />

        <!--/Headline -->

        <l-rich-text-editor
            v-model="notes"
            :content="notes"
            @input="onNotesInput"
        ></l-rich-text-editor>

        <!-- Other user's notes -->
        <div v-for="participant in otherParticipants" :key="participant._id">
            <div v-if="participant.notes">
                <div class="hr-small"></div>

                <div class="agenda-question">
                    <span>{{
                        $t("meetings.labelSharedNotesOther", {
                            firstname: participant.firstname,
                            lastname: participant.lastname,
                        })
                    }}</span>
                </div>

                <div class="row" style="margin-top: 10px">
                    <div class="col-md-12">
                        <div v-html="participant.notes"></div>
                    </div>
                </div>

                <br />

                <div class="hr-small"></div>
            </div>
        </div>
        <!--/Other user's notes -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import debounce from "lodash.debounce";

import LRichTextEditor from "@/components/LRichTextEditor";

export default {
    components: {
        LRichTextEditor,
    },
    props: {
        meeting: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            updatingNotes: false,
            editingNotes: false,
            notes: this.meeting.notesCurrent,
            copyNotes: this.meeting.copyNotesCurrent,
        };
    },
    computed: {
        ...mapGetters({
            currentUser: "users/current/user",
        }),
        otherParticipants() {
            return this.meeting.otherUsers.map(participant => ({
                ...participant,
                notes: this.meeting.notesOthers[participant._id] || "",
            }));
        },
    },
    created() {
        this.onNotesInput = debounce(this.updateNotes, 500);
        this.editingNotes = !this.notes;
    },
    methods: {
        toggleCopyNotes() {
            this.copyNotes = !this.copyNotes;

            this.updateNotes();
        },
        updateNotes() {
            this.updatingNotes = true;
            const participants = [...this.meeting.otherUsers, this.currentUser].map(participant =>
                participant._id ? participant._id : participant,
            );

            const data = {
                _id: this.meeting._id,
                participants,
                notesCurrent: this.notes,
                copyNotesCurrent: this.copyNotes,
            };

            this.$store
                .dispatch({
                    type: "meetings/meetings/update",
                    payload: { data },
                })
                .then(() => {
                    this.updatingNotes = false;
                });
        },
        onNotesBlur() {
            this.editingNotes = !this.notes;
        },
    },
};
</script>

<style scoped></style>
